export default __webpack_public_path__ + "static/media/nail_salon.d551fadb.png";